export const checkIsBetaTester = (authorization) => !!(
  authorization &&
    authorization.userPhotographer &&
    authorization.userPhotographer.isBetaTester
);
